import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vant from 'vant';
import global from './mixins/new-global';
import VueLazyload from 'vue-lazyload';
// import {isWechat} from './assets/js/util';
//引入video样式
import './components';

Vue.config.productionTip = false;

Vue.use(vant);
Vue.use(global);
Vue.use(VueLazyload);

const whiteList = [];
// eslint-disable-next-line space-before-function-paren
router.beforeEach(async (to, from, next) => {
  // 配置标题
  if (to.meta.deepth > -1 && from.meta.deepth > -1) {
    window.step = to.meta.deepth - from.meta.deepth;
  } else {
    window.step = 0;
  }
  console.log(window.step);
  if (0) {
    document.title = to.meta.title;
  } else {
    document.title = 'AI';
  }
  next();
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
